<ng-container *transloco="let t; read: 'admin.tenants'">
  <div class="flex h-full min-h-0 flex-col">
    <!-- Header: name + status, and the mock's Edit / Disable / Invite actions -->
    <div class="flex flex-none flex-wrap items-start justify-between gap-3">
      <div class="flex items-center gap-3.5">
        <h1 class="m-0 font-display text-2xl font-bold text-ink-1">{{ tenant()?.name ?? t('detailPage.dash') }}</h1>
        @if (tenant(); as tn) {
          <app-label-badge [dot]="tn.enabled ? 'green' : null">{{ tn.enabled ? t('status.enabled') : t('status.disabled') }}</app-label-badge>
        }
      </div>
      @if (tenant(); as tn) {
        <div class="flex flex-wrap items-center gap-2.5">
          <button
            type="button"
            (click)="openEdit()"
            class="rounded-control border border-hairline bg-card px-4 py-2.5 text-[14px] font-semibold text-ink-1 hover:bg-sunken"
          >
            {{ t('detailPage.actions.edit') }}
          </button>
          <button
            type="button"
            (click)="toggleEnabled()"
            class="rounded-control border border-hairline bg-card px-4 py-2.5 text-[14px] font-semibold text-ink-1 hover:bg-sunken"
          >
            {{ tn.enabled ? t('detailPage.actions.disable') : t('detailPage.actions.enable') }}
          </button>
          <button
            type="button"
            (click)="invite()"
            class="rounded-control bg-action px-4 py-2.5 text-[14px] font-semibold text-action-text hover:brightness-90"
          >
            {{ t('detailPage.actions.invite') }}
          </button>
        </div>
      }
    </div>

    <!-- Overview | Users tab strip (routed content below) -->
    <div class="mb-5 mt-3.5 flex flex-none items-stretch gap-1 border-b border-hairline">
      @for (tabId of ['overview', 'users']; track tabId) {
        <button
          type="button"
          (click)="showTab($any(tabId))"
          class="relative flex items-center gap-2 border-none bg-transparent px-4 py-3"
        >
          <span
            class="text-[13px] font-bold uppercase tracking-wide"
            [class.text-ink-1]="activeTab() === tabId"
            [class.text-ink-3]="activeTab() !== tabId"
            >{{ t('detailPage.tabs.' + tabId) }}</span
          >
          @if (activeTab() === tabId) {
            <div class="absolute inset-x-3 -bottom-px h-0.5 rounded bg-action"></div>
          }
        </button>
      }
    </div>

    <div class="min-h-0 flex-1">
      <router-outlet />
    </div>
  </div>
</ng-container>

@if (isEditOpen()) {
  <app-edit-tenant-dialog
    [tenantId]="tenantId"
    (close)="closeEdit()"
    (saved)="handleEdited()"
  ></app-edit-tenant-dialog>
}

@if (isInviteOpen()) {
  <app-invite-member-dialog
    [tenantId]="tenantId"
    [tenantName]="tenant()?.name"
    (close)="closeInvite()"
    (sent)="handleInvited()"
  ></app-invite-member-dialog>
}
